import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-truncate-text',
  imports: [CommonModule],
  templateUrl: './truncate-text.component.html',
  styleUrl: './truncate-text.component.scss',
})
export class TruncateTextComponent implements OnChanges {
  /** Texto bruto (pode conter HTML do p-editor, &nbsp;, tags, etc.) */
  @Input() text: string = '';
  /** Limite de caracteres antes de mostrar "ver mais" */
  @Input() limit: number = 150;

  cleanedText: string = '';
  truncatedText: string = '';
  isExpanded: boolean = false;
  needsTruncation: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] || changes['limit']) {
      this.processText();
    }
  }

  private processText(): void {
    if (!this.text) {
      this.cleanedText = '';
      this.truncatedText = '';
      this.needsTruncation = false;
      return;
    }

    // Remove tags HTML (do p-editor) e &nbsp;
    const withoutNbsp = this.text.replace(/&nbsp;/gi, ' ');
    const withoutHtml = withoutNbsp.replace(/<[^>]*>/g, '');
    // Normalizar espaços múltiplos e trim
    const normalized = withoutHtml.replace(/\s+/g, ' ').trim();

    this.cleanedText = normalized;
    this.needsTruncation = normalized.length > this.limit;

    if (this.needsTruncation) {
      this.truncatedText = normalized.substring(0, this.limit).trimEnd() + '...';
    } else {
      this.truncatedText = normalized;
    }
  }

  toggle(event: Event): void {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }
}
